export const ACC_KEY = "693f87b484700b6d0ac70b865527ddda";
export const API_URL = "https://www.powerlego.com/ApiGateway/";